import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe para formatear RUT chileno.
 *
 * @remarks
 * Transforma un RUT sin formato (ej: 123456789) a su formato con puntos y guion (ej: 12.345.678-9).
 *
 * @example
 * ```html
 * {{ persona.rutDni | rutFormat }}
 * ```
 */
@Pipe({
    name: 'rutFormat'
})
export class RutFormatPipe implements PipeTransform {
    transform(value: string): string {
        return this.format(value);
    }

    /**
     * Formatea un RUT chileno agregando puntos y guion.
     *
     * @param rut - RUT sin formato
     * @returns RUT formateado (ej: 12.345.678-9) o string vacio si es invalido
     */
    format(rut: string): string {
        rut = this.clean(rut);

        let result = rut.slice(-4, -1) + '-' + rut.substr(rut.length - 1);
        for (let i = 4; i < rut.length; i += 3) {
            result = rut.slice(-3 - i, -i) + '.' + result;
        }

        if (result === '-') result = "";
        return result;
    }

    /**
     * Limpia un RUT removiendo caracteres no validos.
     *
     * @param rut - RUT potencialmente con formato
     * @returns RUT limpio (solo digitos y K)
     */
    clean(rut: string): string {
        return typeof rut === 'string'
            ? rut.replace(/^0+|[^0-9kK]+/g, '').toUpperCase()
            : '';
    }

}
